import { useEffect, useState } from "react";
import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { mapSailor } from "../util/mapSailor";

export const useSailor = (sailorId) => {
  const [sailor, setSailor] = useState();
  const [value, loading, error] = useDocument(doc(db, "sailors", sailorId), {
    snapshotListenOptions: { includeMetadataChanges: true },
  });
  useEffect(() => {
    const run = async () => {
      if (value) {
        const sailor = await mapSailor(value);
        setSailor(sailor);
      }
    };
    run();
  }, [value, sailorId]);

  return { sailor, loading, error };
};
